/**
 * Per-locale i18n instance cache. Components read their `locale` attribute and call
 * `i18nFor(locale)` for UI chrome copy — business content always arrives via GraphQL.
 */
import type { Locale } from "@mb-group/shared-types";
import { createI18n, isLocale, type I18n } from "@mb-group/i18n";

const cache = new Map<Locale, I18n>();

export function i18nFor(locale: string): I18n {
	const key: Locale = isLocale(locale) ? locale : "pl";
	let instance = cache.get(key);
	if (!instance) {
		instance = createI18n(key);
		cache.set(key, instance);
	}
	return instance;
}
